/* hs-eslint ignored failing-rules */

import { logNetworkError } from 'calling-error-reporting/report/error';
import { TourCompletionStatus } from 'onboarding-tours-client/constants';
import { getTourStatus, setTourStatus } from 'onboarding-tours-client/onboardingToursClient';
import { useCallback, useEffect, useState } from 'react';
import { shouldDisableOnboardingTour } from 'calling-remote-common/utils/shouldDisableOnboardingTour';
export const useCallingOnboarding = ({
  hasCallingAccess,
  isLoadingCallingAccess,
  isOpen
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [callingOnboardingStatus, setCallingOnboardingStatus] = useState(null);
  const setCallingOnboarding = useCallback(tourStatus => {
    setTourStatus('inbound-calling-announcement-key', tourStatus, true).then(() => {
      setCallingOnboardingStatus(tourStatus);
    }).catch(networkError => {
      logNetworkError({
        networkError,
        error: new Error('Error setting onboarding tour status'),
        tags: {
          requestName: '/onboarding/tours/v1/status'
        }
      });
    });
  }, [setCallingOnboardingStatus]);
  useEffect(() => {
    if (isLoadingCallingAccess || !isOpen) {
      return;
    }
    if (hasCallingAccess === false || shouldDisableOnboardingTour()) {
      setCallingOnboardingStatus(TourCompletionStatus.COMPLETE);
      setIsLoading(false);
      return;
    }
    if (callingOnboardingStatus === null) {
      getTourStatus('inbound-calling-announcement-key', true).then(res => {
        setCallingOnboardingStatus(res.status);
        setIsLoading(false);
      }).catch(() => {
        setCallingOnboardingStatus(TourCompletionStatus.COMPLETE);
        setIsLoading(false);
      });
    }
  }, [callingOnboardingStatus, hasCallingAccess, isOpen, isLoadingCallingAccess]);
  return {
    isLoading,
    callingOnboardingStatus,
    setCallingOnboarding
  };
};